<template>
    <div id="app">
        <a-spin :hidden="!isLoading" class="loading" :spinning="isLoading" />
        <a-config-provider :locale="locale">
            <router-view v-if="isRouterAlive" />
        </a-config-provider>
    </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload
        };
    },
    data() {
        return {
            isRouterAlive: true,
            spinning: false,
            locale: zhCN
        };
    },
    watch: {
        $route: {
            handler(to, from) {
                setTimeout(() => {
                    // 避免首次获取不到window._czc
                    if (window._czc) {
                        const location = window.location;
                        const contentUrl = location.pathname + location.hash;
                        const refererUrl = '/';
                        // 用于发送某个URL的PV统计请求，
                        window._czc.push(['_trackPageview', contentUrl, refererUrl]);
                    }
                }, 300);
            },
            immediate: true // 首次进入页面即执行
        }
    },
    computed: {
        isLoading() {
            if (this.$store.getters.loading == 0) {
                return false;
            } else {
                return true;
            }
        }
    },
    created() {
        this.getOtherConfig();
        this.cnzzGet();
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        },
        getOtherConfig() {
            this.api.get_public_Info().then(res => {
                if (res.data && res.data.description) {
                    window.sessionStorage.other_config = res.data.description;
                    // this.reload()
                }
            });
        },
        cnzzGet() {
            this.api.get_cnzzGetconfig().then(res => {
                console.log(res.data);
                const script = document.createElement('script');
                script.language = 'JavaScript';
                script.src = `${res.data}`;
                document.body.appendChild(script);
            });
        }
    }
};
</script>

<style scoped>
@import '/css/App.css';
.loading {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.5);
}
</style>

<style>
.ant-spin-container {
    height: 100%;
}
.ant-spin-blur {
    height: 100%;
}
.ant-spin-nested-loading > div > .ant-spin {
    height: 100%;
}
/*包含以下四种的链接*/
a {
    text-decoration: none;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none;
}
/* 正在点击的链接*/
a:active {
    text-decoration: none;
}
.ant-pagination-item-active {
    border-color: #2b9a34;
}

.ant-pagination-item-active a {
    color: #2b9a34;
}
.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2b9a34 !important;
    border-color: #2b9a34 !important;
}

.ant-input-search-button {
    background: #2b9a34 !important;
    border: none !important;
    height: 40px;
    width: 60px;
}

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    padding: 0;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
}

body {
    padding: 0 !important;
    margin: 0 !important;
    /* overflow: hidden; */
    width: 100%;
    height: 100%;
    position: relative !important;
}

html,
body,
#app {
    height: 100%;
    padding: 0;
    margin: 0;
}

@primary-color {
}

.ant-input {
    outline: #2b9a34 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue